import { createSelector } from 'reselect';

import type { ScrollOffset } from 'state/scroll/reducer';
import type { RootState } from 'state/types';

const getScrollState = ({ scroll }: RootState) => scroll;

export const getOffsetForKey = (key: string) =>
  createSelector(getScrollState, ({ offsetByKey }): ScrollOffset | undefined => offsetByKey[key]);
